import {I18nProvider} from "@/components/shop/I18nProvider";
import {SessionProvider} from "@/components/shop/SessionProvider";
import {ShopSiteProvider} from "@/components/shop/ShopSiteProvider";
import {ShopMaintenanceBanner} from "@/components/shop/ShopMaintenanceBanner";
import {CartDrawerProvider} from "@/components/shop/CartDrawerProvider";
import {MobileMenuProvider} from "@/components/shop/MobileMenuProvider";
import {ShopChrome} from "@/components/shop/ShopChrome";
import {CookieBanner} from "@/components/shop/CookieBanner";
import {ScrollToTop} from "@/components/shop/ScrollToTop";
import {AuthGate} from "@/components/shop/AuthGate";
import {ShopBody} from "@/components/shop/ShopBody";
import {GoogleAnalytics} from "@/components/shop/GoogleAnalytics";
import {ChunkReload} from "@/components/shop/ChunkReload";
import {LegacyStyles} from "@/components/shop/LegacyStyles";

export function ShopLayout() {
  return (
    <I18nProvider>
      <ShopSiteProvider>
        <SessionProvider>
          <CartDrawerProvider>
            <MobileMenuProvider>
              <LegacyStyles />
              <ScrollToTop />
              <ShopMaintenanceBanner />
              <ShopChrome>
                <AuthGate>
                  <ShopBody />
                </AuthGate>
              </ShopChrome>
              <CookieBanner />
              <GoogleAnalytics />
              <ChunkReload />
            </MobileMenuProvider>
          </CartDrawerProvider>
        </SessionProvider>
      </ShopSiteProvider>
    </I18nProvider>
  );
}
